import PropTypes from "prop-types";
import React, { useState } from "react";
import Cookies from "js-cookie";
import { useStylesHelpVideo } from "../utils/mantine/useStylesHelpVideo";
import { Box, Image } from "@mantine/core";
import CustomAnchor from "./mantineCustomComponents/CustomAnchor";

const NeedHelp = ({
  staticBasePath,
  linkDocs,
  linkVideo,
  verificationMethod,
}) => {
  //css classes
  const { classes: classesHelpVideo } = useStylesHelpVideo();

  const [helpNeedIsActive, setHelpNeedIsActive] = useState(() => {
    const cookieValue = Cookies.get("helpNeedIsActive");
    return cookieValue !== undefined ? JSON.parse(cookieValue) : true;
  });

  const handleHelpNeedClick = () => {
    setHelpNeedIsActive(true);
    Cookies.set("helpNeedIsActive", JSON.stringify(true));
  };
  const handleHelpNeedClickClose = () => {
    setHelpNeedIsActive(false);
    Cookies.set("helpNeedIsActive", JSON.stringify(false));
  };
  return (
    <Box
      className={` ${classesHelpVideo.helpVideo}
  ${helpNeedIsActive ? "active" : ""}`}
    >
      <Image
        w="1.1em"
        className="help__video-close"
        onClick={handleHelpNeedClickClose}
        src={`${staticBasePath}public/images/svg/rb-need-help-close.svg`}
        alt="Close"
      />
      <Image
        className="help__video-icon"
        onClick={handleHelpNeedClick}
        src={`${staticBasePath}public/images/svg/rb-icon-need-help.svg`}
        alt="Help"
      />

      <Box className="help__video-text">Need help?</Box>
      {verificationMethod === "portfolio" ? (
        <>
          <Box className="help__video-link">
            See
            <CustomAnchor
              text="how to stamp a portfolio"
              componentClasses="link anchor"
              target="_blank"
              href="https://docs.vbase.com/use-case-how-tos/stamping-portfolios"
            ></CustomAnchor>
            .
          </Box>
        </>
      ) : (
        <>
          <Box className="help__video-link">
            See how-to
            <CustomAnchor
              text="docs"
              componentClasses="link anchor"
              target="_blank"
              href={linkDocs}
            ></CustomAnchor>{" "}
            or
            <CustomAnchor
              text="video"
              componentClasses="link anchor"
              target="_blank"
              href={linkVideo}
            ></CustomAnchor>
          </Box>
        </>
      )}
    </Box>
  );
};
NeedHelp.propTypes = {
  staticBasePath: PropTypes.string.isRequired,
  linkDocs: PropTypes.string.isRequired,
  linkVideo: PropTypes.string.isRequired,
  verificationMethod: PropTypes.string,
};
export default NeedHelp;
